import { statsRequestShowSelect } from "../../../actions/stats";
import { fetchStatOptions } from "../../../actions/stats_options";
import StatsPage from "./stats_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getFormValues, change } from "redux-form";
import get from "lodash/get";
import {
  ShowsForUserActionManager,
  EpisodesByShowActionManager,
} from "../../../action_managers/shows";
import {
  DownloadStatsActionManager,
  InsertionStatsActionManager,
} from "../../../action_managers/stats";
import { withPageTitle } from "../../lib/WithPageTitle";
import "mapbox-gl/dist/mapbox-gl.css";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    stats: state.stats.stats,
    isLoading:
      state.stats.isLoading ||
      state.shows.isLoading ||
      state.statsOptions.isLoading ||
      get(state.episodesByShow, [state.stats.selectedShowUUID, "isLoading"]),
    errorMessage: state.stats.errorMessage || state.shows.errorMessage,
    statsForm: getFormValues("stats-filter")(state),
    statsOptions: state.statsOptions,
    shows: state.shows.shows,
    showUUID: state.stats.selectedShowUUID,
    episodesByShow: state.episodesByShow,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchStats: (formValues, user, requestID) => {
      var { statsType, ...filters } = formValues;
      if (statsType === "downloads") {
        dispatch(new DownloadStatsActionManager({ filters, user, requestID }).run());
      } else {
        dispatch(new InsertionStatsActionManager({ filters, user, requestID }).run());
      }
    },
    fetchShowsForUser: user => {
      return dispatch(new ShowsForUserActionManager({ user }).run());
    },
    fetchEpisodesForShow: (showUUID, user) => {
      return dispatch(new EpisodesByShowActionManager({ showUUID, user }).run());
    },
    setShowUUID: showUUID => {
      dispatch(statsRequestShowSelect(showUUID));
    },
    clearEpisodeUUID: () => {
      dispatch(change("stats-filter", "episodeUUID", ""));
    },
    clearShowUUID: () => {
      dispatch(change("stats-filter", "showUUID", ""));
    },
    fetchStatsOptions: () => {
      dispatch(fetchStatOptions());
    },
  };
}

const StatsPageWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(StatsPage));

export default withPageTitle(StatsPageWrapper, "Analytics");
